export default __webpack_public_path__ + "static/media/svg-User.93a0ad09.svg";